import { reduxForm } from 'redux-form';
import { push } from 'react-router-redux/lib/actions';
import validateTool from '../../../utilites/validate';
import {PromotionCRUDActions} from '../../../actions/promotion';
import { PROMOTION_ROUTER_ROOT } from '../constants';
import PromotionEditForm from './PromotionEditForm';

// new way of actions. Has to have less memory in use;
let CRUDActions = new PromotionCRUDActions();

const validateForm = (data) => {
  return validateTool(data, {
    'title': {
      presence: true
    },
    'description': {
      presenceContent: {
        message: '^Description is missing'
      }
    },
    'product': {
      presence: true
    }
  }) || {};
};

export default reduxForm(
  {
    form: 'promotion_edit_form',
    fields: ['image', 'title', 'description', 'short_content', 'product', 'vip', 'expiredDate'],
    returnRejectedSubmitPromise: true,
    validate: validateForm
  },
  ({ promotion: { model = {} } }) => ({
    model: model,
    disabled: model && model.published,
    isPublished: model && model.isPublished,
    isDisabledSelectProduct: model && !model.isNew(),
    initialValues: model
      ? {
        expiredDate: model.expiredDate,
        product: model.product,
        title: model.title,
        vip: model.vip,
        description: model.description,
        short_content: model.short_content,
        image: model.image
      }
      : {}
  }),
  dispatch => ({
    save: (item, data) => dispatch(CRUDActions.save(item, data)),
    publish: (item) => dispatch(CRUDActions.publish(item)),
    onClose: () => {
      dispatch(push(PROMOTION_ROUTER_ROOT));
      dispatch(CRUDActions.onCloseEditForm());
    }
  })
)(PromotionEditForm);



// WEBPACK FOOTER //
// ./src/components/Promotions/PromotionEditForm/index.js